import {
  LOGIN_CLEAR,
  LOGIN_CLEAR_ERROR,
  LOGIN_START,
  LOGIN_ERROR,
  LOGIN_REQUIRE_MFA,
  LOGIN_USER_INFO
} from '../constants/actionTypes'
import { getUserSelf, userLogin, userLoginEula, codeGrant } from '../../../api'
import { createSession, setEulaExpired, getSessionData } from '../../../redux/actions'
import moment from 'moment'
import { AppDispatch } from '../../../../../store'

export const clearLogin = () => ({ type: LOGIN_CLEAR })

export const clearLoginError = () => ({ type: LOGIN_CLEAR_ERROR })

export const startLogin = () => ({ type: LOGIN_START })

export const loginRequireMFA = () => ({ type: LOGIN_REQUIRE_MFA })

export const loginUserInfo = (payload: { userInfo: any }) => ({ type: LOGIN_USER_INFO, payload })

export const loginError = (payload: { errorAuth: string; errorOther: string }) => {
  return ({ type: LOGIN_ERROR, payload })
}

export const loginFromCallback = (data: { token: { access_token: string } }) => {
  return async (dispatch: AppDispatch) => {
    if (data && data.token && data.token.access_token) {
      const newData = {
        ...data.token,
        token_creation_time: moment().format(),
        internal_date: moment().format()
      }
      localStorage.setItem('Tinybots.session', JSON.stringify(newData))
      dispatch(createSession(newData))
      const { data: user } = await getUserSelf()
      dispatch(loginUserInfo({ userInfo: user }))
    }
  }
}

export const loginFromCodeGrant = (code: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      const response = await codeGrant({ code })
      if (response.data && response.data.token && response.data.token.access_token) {
        const newData = {
          ...response.data.token,
          token_creation_time: moment().format(),
          internal_date: moment().format()
        }
        localStorage.setItem('Tinybots.session', JSON.stringify(newData))
        dispatch(createSession(newData))
        const { data: user } = await getUserSelf()
        dispatch(loginUserInfo({ userInfo: user }))
        dispatch(getSessionData())
        return response.data
      }
    } catch (err) {
      throw err
    }
  }
}

export const loginUser = (payload: { username: string; password: string; eula?: boolean; usedPassword?: string }) => {
  return async (dispatch: (arg0: { type: string; session?: any; payload?: any }) => void) => {
    const { eula, ...data } = payload || {}
    dispatch(startLogin())
    try {
      const response = await (eula ? userLoginEula(data) : userLogin(data))
      if (response.data && response.data.token && response.data.token.access_token) {
        const newData = {
          ...response.data.token,
          token_creation_time: moment().format(),
          internal_date: moment().format()
        }

        localStorage.setItem('Tinybots.session', JSON.stringify(newData))
        dispatch(createSession(newData))
      } else if (response.data && response.data.needMfa === true) {
        dispatch(loginRequireMFA())
      } else {
        dispatch(loginError({ errorAuth: 'AC.LOGIN.ERROR_UNKNOWN', errorOther: '' }))
      }
    } catch (err) {
      const e = err as any
      if (e.response && e.response.data && e.response.data.eulaVersionUrl) {
        dispatch(clearLogin())
        dispatch(setEulaExpired(e.response.data.eulaVersionUrl))
      } else if (e.response && e.response.status === 403 && e.response.data && e.response.data.errorMessage === 'Must use SSO') {
        const error = { errorAuth: 'AC.LOGIN.ERROR_SSO_REQUIRED', errorOther: '' }
        dispatch(loginError(error))
      } else {
        const error = e.response && e.response.status === 401
          ? { errorAuth: 'AC.LOGIN.ERROR_WRONG_EMAIL_PASSWORD', errorOther: 'AC.LOGIN.ERROR_AUTH' }
          : { errorAuth: 'AC.LOGIN.ERROR_UNKNOWN', errorOther: '' }
        dispatch(loginError(error))
      }
    }
  }
}

export const loginWithMFA = (payload: { username: string; password: string; mfaCode?: string; eula?: boolean }) => async (dispatch: (arg0: { type: string; session?: any; payload?: any }) => void) => {
  const { eula, ...data } = payload || {}
  dispatch(startLogin())
  try {
    const response = await (eula ? userLoginEula(data) : userLogin(data))
    if (response.data && response.data.access_token) {
      const newData = {
        ...response.data,
        token_creation_time: moment().format(),
        internal_date: moment().format()
      }

      localStorage.setItem('Tinybots.session', JSON.stringify(newData))
      dispatch(createSession(newData))
    } else {
      dispatch(loginError({ errorAuth: 'AC.LOGIN.ERROR_UNKNOWN', errorOther: '' }))
    }
  } catch (err) {
    const e = err as any
    let error = { errorAuth: 'AC.LOGIN.ERROR_UNKNOWN', errorOther: '' }
    if (e.response && e.response.status === 403 && e.response.data && e.response.data.errorMessage === 'Must use SSO') {
      error = { errorAuth: 'AC.LOGIN.ERROR_SSO_REQUIRED', errorOther: '' }
    } else if (e.response && e.response.status === 401) {
      error = { errorAuth: 'AC.LOGIN.ERROR_WRONG_EMAIL_PASSWORD', errorOther: 'AC.LOGIN.ERROR_AUTH' }
    }

    dispatch(loginError(error))
  }
}